﻿import React from "react";
import classNames from "classnames";
import AvisFooter from "../footer/AvisFooter";
import { AvisDescriptiveText } from "../form/AvisDescriptiveText";

interface IUnauthorizedLayoutProps {
  children?: React.ReactNode;
  info?: React.ReactNode | string;
  hideLogo?: boolean;
  textToDisplayKey?: string;
  className?: string;
}

export function UnauthorizedLayout(props: Readonly<IUnauthorizedLayoutProps>) {
  const { children, info, className, hideLogo, textToDisplayKey } = props;

  const componentClassName = classNames("avis-unauthorized-layout", className);

  const renderInfoSection = () => {
    if (!info) return;

    return <div className="avis-unauthorized-layout-info">{info}</div>;
  };

  const renderLogo = () => {
    if (hideLogo) return null;

    return (
      <div className="avis-unauthorized-layout-logo avis-logo">
        <img src="/akka_laa_logo.svg" alt="AKKA/LAA logo" />
        {textToDisplayKey && <AvisDescriptiveText textKey={textToDisplayKey} />}
      </div>
    );
  };

  return (
    <div className={componentClassName}>
      <div className="avis-unauthorized-layout-content-wrapper">
        {renderLogo()}
        <div className="avis-unauthorized-layout-content">{children}</div>
      </div>
      {renderInfoSection()}
      <AvisFooter />
    </div>
  );
}
